import styled from 'styled-components';

import { ProfileInfo as BaseProfileInfo } from '@xing-com/profile-info';
import { spaceXL } from '@xing-com/tokens';
import { Headline } from '@xing-com/typography';

const Title = styled(Headline)`
  text-align: center;
`;

const PeakAndPopMembers = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;
const ScrollableContainer = styled.div`
  overflow: auto;
`;

const MemberContainer = styled(ScrollableContainer)`
  margin-top: ${spaceXL};
`;

const ProfileInfo = styled(BaseProfileInfo)`
  padding: 0;
`;

const ProfileInfoAnchor = styled.a`
  display: block;
  color: inherit;
  text-decoration: none;
  margin-bottom: ${spaceXL};
  cursor: pointer;

  &:last-child {
    margin-bottom: 0;
  }
`;

export default {
  Title,
  ProfileInfo,
  ProfileInfoAnchor,
  PeakAndPopMembers,
  MemberContainer,
};
